import type { SessionSlot } from '@features/customization-session/types';

import { Info } from 'lucide-react';

import { Button } from '@shared/components/ui/button';
import { Alert, AlertTitle } from '@shared/components/ui/alert';
import {
  Dialog,
  DialogBody,
  DialogTitle,
  DialogHeader,
  DialogFooter,
  DialogContent,
  DialogDescription,
} from '@shared/components/ui/dialog';

type Props = {
  slot: SessionSlot;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/** Confirms that a product leaves the session: it goes back in its box and is to be customized again. */
export const RemoveProductDialog = ({ slot, busy, onConfirm, onClose }: Props) => (
  <Dialog onOpenChange={(open) => !open && !busy && onClose()} open>
    <DialogContent className="max-w-100" showCloseButton={false}>
      <DialogHeader className="border-b border-border">
        <DialogTitle>Retirer le produit de la session</DialogTitle>
        <DialogDescription className="sr-only">Confirmer le retrait du produit</DialogDescription>
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4 py-6">
        <p>
          Retirer <b>{slot.product}</b> ({slot.order}) de l&apos;emplacement <b>{slot.number}</b> du gabarit ?
        </p>
        <Alert className="border-info/50 text-info">
          <Info />
          <AlertTitle className="line-clamp-none">
            Le produit retourne dans sa caisse{slot.box ? ` ${slot.box}` : ''}
            {slot.workshop ? ` (${slot.workshop})` : ''} et redevient à personnaliser. Son numéro de gabarit reste vide.
          </AlertTitle>
        </Alert>
      </DialogBody>
      <DialogFooter>
        <Button disabled={busy} onClick={onClose} variant="ghost">
          Annuler
        </Button>
        <Button disabled={busy} onClick={onConfirm} variant="destructive">
          Retirer
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
